import { t } from "i18next";

import { Box, Card, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import FAQList from "@/src/components/molecules/FAQList/FAQList";

import { HOMEPAGE_CONTAINER_STYLES } from "@/src/pages/consumer/HomePage/homePage.constants";

export const HomePageFAQList = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card
        elevation={4}
        sx={{
          background: "background.paper",
          borderRadius: "2rem",
          ...HOMEPAGE_CONTAINER_STYLES,
          marginY: 4,
          maxWidth: "1200px",
          marginLeft: [2, 6],
          marginRight: [2, 6],
          ul: {
            pl: 0
          }
        }}
        id="HomePageFAQContainer"
      >
        <Typography variant="h2" sx={{ pl: 1 }}>
          {t("consumer.homePage.faqTitle")}
        </Typography>
        <Typography variant="h3" sx={{ pb: 2, pl: 1 }}>
          {t("consumer.homePage.faqBody")}
        </Typography>

        <Box sx={{ mt: 2, fontWeight: theme.typography.fontWeightBold }}>
          <FAQList />
        </Box>
      </Card>
    </Box>
  );
};
